// extracted by mini-css-extract-plugin
export default {"pageLayout":"JobDescriptionsStats-module__pageLayout___iTTDW"};